import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './unidadeReservaForm';
import FormatUtils from '../common/formatUtils/FormatUtils';

import { setModoTela, initForm, salvar, excluir, getListaReserva as getLista, alterarReservaPerdida, alterarVenda } from './unidadeActions';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class UnidadeReserva extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

	componentWillMount() {
		this.props.getLista(this.props.id_empreendimento);
	}

	render() {
		return (
			<div>
				<Content>
					{this.lista()}
				</Content>
			</div>
		)
	}

	lista() {
		return (
			<ContentCard>

				{this.modalReserva()}

				<ContentCardBody>
					<input className='form-control'
						placeholder='Pesquisar'
						type='text'
						value={this.state.pesquisar}
						onChange={e => {
							this.setState({ ...this.state, pesquisar: e.target.value });
						}} />
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Lote</Th>
								<Th alignCenter>Corretor</Th>
								<Th alignCenter>Imobiliária</Th>
								<Th alignCenter>Data da Reserva</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.numero} ${item.descricao}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id}>
									<Td alignCenter>{item.numero_unidade}</Td>
									<Td alignCenter>{item.nome_usuario_reserva}</Td>
									<Td alignCenter>{item.nome_imobiliaria}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_reserva)}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'primary'}
											icon={'fas fa-eye'}
											visible={true}
											event={() => {
												this.setState({
													registro: {
														...item
													}
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalReserva() {

		if (!this.state.registro) {
			return null;
		}

		return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Reserva</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, registro: null })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ overflowY: 'scroll' }}>

							<Row>
								{this.state.registro.cadastro.map(item => {

									let componente = null;
									let casas = null;
									if (item.id_tipo == 1) {
										//Texto
										return (
											<LabelAndInput
												key={item.id}
												label={item.nome} placeholder='Informe'
												cols='12 4 4 4'
												readOnly={'readOnly'}
												value={item.valor}
												onChange={data => {
													this.props.initForm({
														...this.state.registro,
														cadastro: this.state.registro.cadastro.map(itemAux => {
															if (itemAux.id == item.id) {
																return {
																	...itemAux,
																	valor: data.target.value
																};
															} else {
																return itemAux;
															}
														})
													});
												}} />
										)
									} else if (item.id_tipo == 2) {
										//Número Inteiro
										return (
											<LabelAndInputNumber
												key={item.id}
												label={item.nome} placeholder='Informe'
												cols='12 4 4 4'
												readOnly={'readOnly'}
												value={item.valor}
												casas={0}
												onChange={data => {
													this.props.initForm({
														...this.state.registro,
														cadastro: this.state.registro.cadastro.map(itemAux => {
															if (itemAux.id == item.id) {
																return {
																	...itemAux,
																	valor: data.target.value
																};
															} else {
																return itemAux;
															}
														})
													});
												}} />
										);
									} else if (item.id_tipo == 3) {
										//Número Decimal
										return (
											<LabelAndInputNumber
												key={item.id}
												label={item.nome} placeholder='Informe'
												cols='12 4 4 4'
												readOnly={'readOnly'}
												value={item.valor}
												casas={2}
												onChange={data => {
													this.props.initForm({
														...this.state.registro,
														cadastro: this.state.registro.cadastro.map(itemAux => {
															if (itemAux.id == item.id) {
																return {
																	...itemAux,
																	valor: data.target.value
																};
															} else {
																return itemAux;
															}
														})
													});
												}} />
										);
									} else if (item.id_tipo == 4) {
										//4 - Data
										return (
											<LabelAndInputDate
												key={item.id}
												label={item.nome} placeholder='Informe'
												cols='12 4 4 4'
												readOnly={'readOnly'}
												value={item.valor}
												onChange={data => {
													this.props.initForm({
														...this.state.registro,
														cadastro: this.state.registro.cadastro.map(itemAux => {
															if (itemAux.id == item.id) {
																return {
																	...itemAux,
																	valor: data.target.value
																};
															} else {
																return itemAux;
															}
														})
													});
												}} />
										);
									} else if (item.id_tipo == 5) {
										//5 - Anexo
										return (										
											<Grid cols='12 12 12 12'
												key={item.id}>
												<label>{item.nome}</label>
												{item.valor &&
												<Grid cols='12 12 12 12'>
													<button
														type='button'
														class='btn btn-flat btn-outline-primary'
														onClick={() => {													
														// cria link temporário
														const link = document.createElement('a');
														link.href = item.valor.arquivoBase64;
														link.download = item.valor.filename;
														link.click();
														}} >
														Baixar
													</button>
												</Grid>}
											</Grid>
										);
									}
								})}

							</Row>

							<div style={{ padding: 16 }}>
								<Row alignCenter>
									<Grid cols='6 6 6 4'>
										<Button
											text={'Liberar Reserva'}
											type={'primary'}
											icon={'fa fa-plus'}
											event={() => {
												this.props.alterarReservaPerdida(this.state.registro);
												this.setState({ ...this.state, registro: null })
											}} />
									</Grid>
									<Grid cols='6 6 6 4'>
										<Button
											text={'Venda Confirmada'}
											type={'success'}
											icon={'fa fa-plus'}
											event={() => {
												this.props.alterarVenda(this.state.registro);
												this.setState({ ...this.state, registro: null })
											}} />
									</Grid>
								</Row>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.unidade,
	modoTela: state.unidade.modoTela,
	lista: state.unidade.listaReserva
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, alterarReservaPerdida, alterarVenda }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UnidadeReserva);
